import { preparePhone } from '@/helpers/functions'
import Repository from './Repository'

const action = '/dispatchers/drivers'
const params = '?expand=is_6ndfl_approved,master-approve,master-approve-status'

export default {
  getDriver(page = false, status) {
    let pagination = ''
    let filter = ''

    if (page) {
      pagination = '&page=' + page
    }
    if (status) {
      filter = `&master_approve_status=${status}`
    }

    return Repository.get(action + params + pagination + filter)
  },
  getFilterDriver(search) {
    let params = ''

    for (let key in search) {
      params += params ? '&' : '?'
      params += `${key}=${search[key]}`
    }

    return Repository.get(action + params)
  },
  findDriverByCarrierInn(payload, expand) {
    return Repository.get(`${action}?${payload}&${expand}`)
  },
  postDriver({
    fio,
    driver_licence,
    passport,
    user_org_inn,
    carrier_name,
    carrier_inn,
  }) {
    return Repository.post(action, {
      fio,
      driver_licence,
      passport,
      user_org_inn,
      carrier_name,
      carrier_inn,
    })
  },
  updateDriver(id, fields) {
    fields.phone = fields.phone ? preparePhone(fields.phone) : null

    return Repository.put(`${action}/${id}`, {
      ...fields,
    })
  },
  deleteDriver(id) {
    return Repository.delete(`${action}/${id}`)
  },
}
